import { GameRowValue } from '@sg/backend/src/lib/db/getGameOr404.ts'
import { useSearchParams } from '@solidjs/router'
import { Component, DEV, onMount } from 'solid-js'
import { createMutable } from 'solid-js/store'
import toast from 'solid-toast'
import bindViewCtxToWindowV2 from '../lib/bindViewCtxToWindowV2'
import bindEngineToComponentV2 from '../lib/canvas/bindEngineToComponentV2'
import createEngineForGamePlay from '../lib/core/engine/createEngineForGamePlay'
import { Engine } from '../lib/core/engine/Engine.type'
import syncEngineWithPropsRow from '../lib/core/engine/syncEngineWithPropsRow'
import { createMediumArtillaryEntity } from '../lib/core/entity/EntityType/MediumArtillary'
import nextEntityIdFromEngine from '../lib/core/entity/nextEntityIdFromEngine'
import { StateType } from '../lib/core/state/state_type.enum'
import { loadGameFromLocalStorage, LoadGameFromLocalStorageResult } from '../lib/core/Storage/LocalStorage/localStorageEngineLoader'
import registerTouchEventsV2 from '../lib/dom/event/registerTouchEventsV2'
import bindCameraToUserPreferences from '../lib/three/camera/bindCameraToUserPreferences'
import createMainCamera from '../lib/three/fn/createMainCamera'
import createMountedMainCanvasElement from '../lib/three/fn/createMountedMainCanvasElement'
import createMountedMainRenderer from '../lib/three/fn/createMountedMainRenderer'
import { setEngineThreeMainCamera } from '../lib/three/fn/getSetEngineThreeMainCamera'
import { setEngineThreeMainRenderer } from '../lib/three/fn/getSetEngineThreeMainRenderer'
import { setEngineToast } from '../lib/three/fn/getSetEngineToast'
import onMountStartCameraNearLastAction from '../lib/three/fn/onMountStartCameraNearLastAction'
import useMainScene from '../lib/three/fn/useMainScene'
import createRedirectIfWrongStateTypeEffect from '../rx/effect/createRedirectIfWrongStateTypeEffect'
import createSetEngineAuthPlayerIdFromAuthProfileSignalEffect from '../rx/effect/createSetEngineAuthPlayerIdFromAuthProfileSignalEffect'
import createSetEngineAuthPlayerIdFromLocalEffect from '../rx/effect/createSetEngineAuthPlayerIdFromLocalEffect'
import useCornerWidgetEngine from '../rx/shared/CornerWidget/useCornerWidgetEngine'
import { getAuthProfile } from '../rx/shared/profile/createAuthProfileSignal'
import registerServerSentEvents from '../rx/sse/registerServerSentEvents'
import useLocalBotPlayer from '../rx/use/useLocalBotPlayer'
import EngineContext from './EngineContext'
import GameEndedModal from './GameEndedModal'

interface Props {
  // session: BackendSessionPayload,
  row?: GameRowValue,
  local?: boolean,
}

const componentStateType = StateType.Game

const GamePlayThreeJsCanvas: Component<Props> = (props) => {
  const engine: Engine = createMutable<Engine>(createEngineForGamePlay())

  onMount(() => {
    if (DEV) {
      const [searchParams] = useSearchParams()
      if (searchParams.debug_scenario) {
        import(`../lib/debug/scenario/${searchParams.debug_scenario}.ts`).then((module) => {
          module.default(engine)
        })
        createSetEngineAuthPlayerIdFromAuthProfileSignalEffect(engine, getAuthProfile)
        return
      }
    }
    if (props.local) {
      const loadGamePromise = loadGameFromLocalStorage(engine)
      // eslint-disable-next-line solid/reactivity
      loadGamePromise.then((loadedResult) => {
        if (loadedResult === LoadGameFromLocalStorageResult.NoGameFound) {
          toast.error('No game found in Local Storage.')
          const scene = useMainScene(engine)
          if (scene) {
            // scene.background = new Color(0x000000)
            scene.visible = false
          }
          return
        }

        // something about this breaks the ability to create draftMove UI elements
        // dispatchClient(engine, createStartTurnAction(engine.state.players[0].id)).then(async () => {
        //     resetEngineToDefaultSelectedTool(engine)
        //     //   const unit = engine.state.ents.find(isEntityInfantry) as InfantryEntity
        //     //   await new Promise(resolve => setTimeout(resolve, 1000))
        //     //   engine.selectedPosition = toCoord(unit)
        //     //   await new Promise(resolve => setTimeout(resolve, 1000))
        //     //   // engine.draftMove = createDraftMove(unit)
        //     //   setHoveredPosition(coord(10, 10))
        // })

        // // eslint-disable-next-line solid/reactivity
        // console.log('engine.actionLogs', deepClone(engine.actionLogs))

        // engine.actionLogs = engine.actionLogs.filter(l => l.action.type > 2000 || l.action.type === 509)
        // console.log('engine.actionLogs', deepClone(engine.actionLogs))
        // saveGameToLocalStorage(engine)

        // const mr0 = createMediumRocketsEntity(nextEntityIdFromEngine(engine.state), 4, 4, engine.state.players[0].id)
        // engine.state.ents.push(mr0)
        // const ma0 = createMediumArtillaryEntity(nextEntityIdFromEngine(engine.state), 4, 5, engine.state.players[0].id)
        // engine.state.ents.push(ma0)
        // engine.state.ents.push(createMediumRocketsEntity(nextEntityIdFromEngine(engine.state), 3, 5, engine.state.players[1].id))
        // createDebugRedAttackArrowPathGroups(engine, mr0)

        // const zoc = new ZoneOfControlGroupV1(engine)
        // scene.add(zoc)
        // zoc.update(mr0)
        // zoc.position.y += 2
        // zoc.visible = false

        // const zoc2 = new BlueZoneOfControlGroup(engine)
        // scene.add(zoc2)
        // zoc2.update([mr0])
        // zoc2.position.y += 2
        // zoc2.visible = false

        // engine.state.players.forEach(player => {
        //   const pg = getPlayerGraph(engine, player.id)
        //   const zoc3 = new BlueZoneOfControlGroup(engine)
        //   scene.add(zoc3)
        //   zoc3.ents = function () {
        //     return engine.state.ents.filter(e => {
        //       if (isEntityUnit(e)) {
        //         return false
        //       }
        //       return true
        //     })
        //   }

        //   // don't give 2 tmp units the same id
        //   const tmpEnts = [...engine.state.ents]

        //   zoc3.color = player.color1
        //   zoc3.update(pg.ents()
        //     .filter(isEntityFactory)
        //     .map((factory: FactoryEntity) => {
        //       const id = randomId(tmpEnts, tmpRng)
        //       const ent = createLightTankEntity(id,
        //         factory.x, factory.y, player.id)
        //       tmpEnts.push(ent)
        //       return ent
        //     }))
        //   zoc3.position.y += 2
        // })
        // zoc.visible = false

        const ma0 = createMediumArtillaryEntity(nextEntityIdFromEngine(engine.state), 4, 5, engine.state.players[0].id)
        engine.state.ents.push(ma0)
      })
    } else {
      onMount(() => {
        syncEngineWithPropsRow(engine, props.row)
      })
      createSetEngineAuthPlayerIdFromAuthProfileSignalEffect(engine, getAuthProfile)
    }
  })

  // eslint-disable-next-line solid/reactivity
  if (props.local) {
    createSetEngineAuthPlayerIdFromLocalEffect(engine)
    useLocalBotPlayer(engine)
  }

  // registerMouseDownEvent(engine)
  // registerMouseUpEvent(engine)
  // registerWheelEvent(engine)
  // registerTouchEventsV2(engine)

  // const isStateDirty = createIsStateDirtyMemo(engine)
  // useConfirmLeaveWithUnsavedChanges(isStateDirty)

  useCornerWidgetEngine(engine)

  registerServerSentEvents(engine)
  createRedirectIfWrongStateTypeEffect(componentStateType, () => engine.state.type, () => engine.state.online?.id)

  setEngineToast(engine, toast)

  const canvasElem = createMountedMainCanvasElement()
  const renderer = createMountedMainRenderer(canvasElem)
  setEngineThreeMainRenderer(engine, renderer)
  const camera = createMainCamera(canvasElem)
  setEngineThreeMainCamera(engine, camera)

  bindViewCtxToWindowV2(engine, canvasElem)
  bindEngineToComponentV2(engine, canvasElem)
  bindCameraToUserPreferences(engine)

  onMountStartCameraNearLastAction(engine)
  
  return <EngineContext.Provider value={engine}>
    <div id="gpc">
      <div id="gvp" ref={(ref: HTMLElement) => {
        // console.log('ref', ref)
        if (ref) {
          registerTouchEventsV2(engine, ref)
          // registerMouseMoveEvent(engine, ref)
        }
      }}>
        {canvasElem}
      </div>
    </div>
    <GameEndedModal />
  </EngineContext.Provider>
}

export default GamePlayThreeJsCanvas
